<template lang="html">
    <simple-layout
        :models-loaded="true"
        :name="getVerbose('settings_breadcrumb')"
    >
        <h3>{{ getVerbose('settings_title') }}</h3>
    </simple-layout>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ])
    }
};
</script>

<style lang="scss" module>
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/settings.vue